import { useCallback, useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { MLB, NBA } from '#src/constants/__generated__/routes.ts';
import { Sport } from '#src/protos/events/shared/events.ts';

export const useGetProtoSport = () => {
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    pathnameRef.current = pathname;
  }, [pathname]);

  return useCallback(() => {
    if (matchPath(catchAll(NBA), pathnameRef.current)) {
      return Sport.NBA;
    }
    if (matchPath(catchAll(MLB), pathnameRef.current)) {
      return Sport.BASEBALL;
    }
    return Sport.FOOTBALL;
  }, []);
};
